<a href="/">
<img id="gainwellLogo" [ngClass]="isDashboard ? 'fcLoginLogoDashboard' : 'fcLoginLogo'" alt="Gainwell Technologies"
 src="../../assets/images/logo.png"></a>
<h1 [ngClass]="isDashboard ? 'fcLoginHeaderDashboard' : 'fcLoginHeader'">
    <a href="/"><span class="fcLoginFraud">File</span>
    <span style="color: white">Capture</span></a>
</h1>